import * as Styled from '../../../../../../components/SearchPage/features/makeModel/components/Skeleton/Skeleton.styled';

const Skeleton = () => {
  const arrayLength = 16;
  // Skeleton mimics models ui structure: Popular (pos 2), 5 popular models, All Models (pos 8), remaining models
  return (
    <Styled.List data-testid="skeleton-list">
      {Array.from({ length: arrayLength }, (_, index: number) => {
        if (index === 1 || index === 7) {
          return (
            <Styled.TitleListItem
              key={`skeleton-item-${index}-title`}
              data-testid={`skeleton-item-${index}-title`}
            >
              <Styled.TitleContainer />
            </Styled.TitleListItem>
          );
        }
        return (
          <Styled.ListItem
            key={`skeleton-item-${index}`}
            data-testid={`skeleton-item-${index}`}
          >
            <Styled.BasicContainer />
          </Styled.ListItem>
        );
      })}
    </Styled.List>
  );
};

export { Skeleton };
